import React, { Component } from "react";
import styles from "./messagesTable.module.scss";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import getDates from "../../shared/services/date.service";
import MessagesTablePaginationControl from "./MessagesTablePaginationControl";
import { Scrollbars } from "react-custom-scrollbars-2";
import { withDashboards } from "../../shared/containers/containerDashboards";
import { states } from "../../reducers/queriesStates";
import { v4 as uuidv4 } from "uuid";

class MessagesTable extends Component {
  constructor(props) {
    super(props);

    const { page, selectIndex, selectPage, scroll } = this.initilizationState(props);

    this.state = {
      data: props.data,
      page: page,
      count: 40,
      totalCount: props.data.length,
      viewData: [],
      selectIndex: selectIndex,
      selectPage: selectPage,
      scroll: scroll,
      selectDate: props.dataState.selectDate,
      dashboardsCodesData: null,
    };
  }

  initilizationState(props) {
    let page = props.dataState.page ? props.dataState.page : 1;
    let selectIndex = props.dataState.selectIndex ? props.dataState.selectIndex : 0;
    let selectPage = props.dataState.selectPage ? props.dataState.selectPage : 1;
    let scroll = props.dataState.scroll;
    let sIdex = 0;

    if (props.dataState.selectDate) {
      const selectDate = new Date(props.dataState.selectDate).valueOf();

      props.data.forEach((item, index) => {
        if (selectDate >= new Date(item.time).valueOf()) {
          sIdex = index;
        }
      });

      page = Math.ceil(sIdex / 40);
      page = page === 0 ? 1 : page;
      selectPage = page;
      selectIndex = 40 + (sIdex - page * 40);
    }

    return {
      page,
      selectIndex,
      selectPage,
      scroll,
    };
  }

  componentDidMount() {
    const { dashboardsCodesDataState, onGetDashboardCodes, dashboardsCodesData } = this.props;

    if (dashboardsCodesDataState !== states.READY) {
      onGetDashboardCodes();
    } else {
      this.setState({ dashboardsCodesData });
    }

    this.pagepagination(this.state.page, this.state.scroll);
  }

  componentDidUpdate(prevProps) {
    const { scrollbar } = this.refs;
    const { selectDate, selectIndex, scroll } = this.state;
    const { dashboardsCodesDataState, dashboardsCodesData } = this.props;

    if (dashboardsCodesDataState === states.READY && prevProps.dashboardsCodesDataState === states.REQUEST) {
      this.setState({ dashboardsCodesData });
    }

    if (this.state.dashboardsCodesData !== null) {
      if (selectDate !== null) {
        const values = scrollbar.getValues();

        const scrollTo = selectIndex !== 0 ? (values.scrollHeight - values.clientHeight) / (40 - selectIndex) : 0;
        this.setState({ selectDate: null, scroll: scrollTo * 8.3 });
      } else {
        scrollbar.scrollTop(scroll);
      }
    }
  }

  componentWillUnmount() {
    const { onSetMessagesData } = this.props;
    const { scrollbar } = this.refs;
    const { selectIndex, page, selectPage } = this.state;

    onSetMessagesData({
      scroll: !!scrollbar ? scrollbar.getScrollTop() : 0,
      selectIndex,
      page: page,
      selectPage: selectPage,
      selectDate: null,
    });
  }

  pagepagination(page, scroll) {
    const { scrollbar } = this.refs;

    if (scroll && scrollbar) {
      scrollbar.scrollTop(!!scroll ? scroll : 0);
    } else {
      this.setState({ scroll: 0 });
    }

    const { data, count } = this.state;
    const start = page * count - count;

    this.setState({ viewData: data.slice(start, start + count), page: page });
  }

  getRowData(rowData) {
    const { dashboardsCodesData } = this.state;

    const getPropertyValue = (key, width = "80px") => {
      return (
        <div className={styles.messagesTableRowItem} style={{ width: width }} key={key}>
          <TooltipWrapper title={`${dashboardsCodesData[key]} : ${rowData[key]}`} position="top">
            <b style={{ border: "none" }}>{key}: </b>
          </TooltipWrapper>
          <span style={{ border: "none" }}>{rowData[key]};</span>
        </div>
      );
    };

    const defaultParams = [
      "COOX",
      "COOY",
      "ALTI",
      "ANGLE",
      "SATE",
      "PDOP",
      "SPEE",
      "SPEEC",
      "DIS",
      "DISIN",
      "IGNI",
      "VOL",
      "USTA",
      "TIDURA",
      "TIMO",
      "TIS",
      "TII",
      "TIEQUI",
      "MACHOU",
      "TER",
    ];

    let values = defaultParams.map((key, index) => {
      return getPropertyValue(key);
    });

    const otherParams = Object.keys(rowData)
      .filter((key) => {
        return !defaultParams.includes(key);
      })
      .filter((key) => {
        return key !== "TI" && key !== "ADD" && key !== "TIE" && key !== "RSA";
      })
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      .map((key) => {
        return getPropertyValue(key);
      });

    values = values.concat(otherParams);
    values.push(getPropertyValue("RSA"));
    values.push(getPropertyValue("ADD", "600px"));

    return values;
  }

  rowClickHandler(selectIndex, date) {
    const { page } = this.state;
    const { scrollbar } = this.refs;

    this.setState({ selectIndex: selectIndex, selectPage: page, scroll: scrollbar.getScrollTop() });
    this.props.handleClickRow(date);
  }

  getRow(row, index) {
    const { selectIndex, selectPage, page } = this.state;

    return (
      <div className={styles.messagesTableRowCursor} key={uuidv4()} onClick={this.rowClickHandler.bind(this, index, row.time)}>
        <div className={getRowStyle()}>
          <div style={{ width: "160px", border: "none" }}>{getDates.getDateFormat3(row.time)}</div>
          <div className={styles.messagesTableRowData} style={{}}>
            {this.getRowData(row.data)}
          </div>
        </div>
      </div>
    );

    function getRowStyle() {
      return selectIndex === index && selectPage === page ? styles.messageasTableSelectRow : styles.messagesTableRow;
    }
  }

  render() {
    const { data, page, count, viewData, dashboardsCodesData } = this.state;

    if (dashboardsCodesData === null) {
      return null;
    }

    const { height = 290 } = this.props;

    return (
      <div className={styles.messagesTableContainer}>
        <div className={styles.messagesTableHeaderContainer}>
          <div className={styles.messagesTableHeaderItem}>Время</div>
          <div className={styles.messagesTableHeaderItem}>Сообщение</div>
        </div>

        <div className={styles.messagesRowsContainer}>
          <Scrollbars style={{ height: height + "px" }} autoHide={true} ref="scrollbar">
            {viewData.map((row, index) => {
              return this.getRow(row, index);
            })}
          </Scrollbars>
        </div>

        <MessagesTablePaginationControl page={page} count={count} totalCount={data.length} onChangeStore={this.pagepagination.bind(this)} />
      </div>
    );
  }
}

export default withDashboards(MessagesTable);
